export default __webpack_public_path__ + "static/media/Belt of Crimson Slaughter (nm).727ab425.jpg";